import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { takeNextPath } from "@/lib/nextPath";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { finalizeGoogle } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sid = decodeURIComponent(m[1]);
    (async () => {
      try {
        const u = await finalizeGoogle(sid);
        toast.success(`Welcome, ${u.name}`);
        window.history.replaceState(null, "", "/");
        nav(takeNextPath(u.role), { replace: true });
      } catch (_e) {
        toast.error("Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, [finalizeGoogle, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-callback">
      <p className="tick-label">Finalizing sign-in…</p>
    </div>
  );
}
